var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5426 5C13.7224 5 11.4362 7.28621 11.4362 10.1064C11.4362 11.3557 12.1418 13.7528 13.3511 14.4064M7.60638 5C4.78621 5 2.5 7.28621 2.5 10.1064C2.5 11.3557 3.2056 13.7528 4.41489 14.4064M17.5 12.3404C17.5 13.7505 16.3569 14.8936 14.9468 14.8936C13.5367 14.8936 12.3936 13.7505 12.3936 12.3404C12.3936 10.9303 13.5367 9.78723 14.9468 9.78723C16.3569 9.78723 17.5 10.9303 17.5 12.3404ZM8.56383 12.3404C8.56383 13.7505 7.42073 14.8936 6.01064 14.8936C4.60055 14.8936 3.45745 13.7505 3.45745 12.3404C3.45745 10.9303 4.60055 9.78723 6.01064 9.78723C7.42073 9.78723 8.56383 10.9303 8.56383 12.3404Z",
    stroke: "#0A090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCite);
export default __webpack_public_path__ + "static/media/cite.202c7153bbfce4b9daf784ef70de0a41.svg";
export { ForwardRef as ReactComponent };